import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../config/constants';
import './NotFoundPage.css';

const NotFoundPage = () => {
    return (
        <div className="not-found-page">
            <h1>404</h1>
            <p>Die Seite wurde nicht gefunden.</p>
            <Link to={ROUTES.DASHBOARD} className="back-link">
                Zurück zum Dashboard
            </Link>
        </div>
    );
};

export default NotFoundPage;